import React from 'react';
import './footer.css';
function Footer() {
  return <div className="footer">Sean Jordaan, 2022</div>;
}

export default Footer;
